"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOldColor = exports.OLD_COLORS = void 0;
const OLD_COLORS = exports.OLD_COLORS = new Set(['White', 'Brown', 'Green', 'Black', 'DarkGrey', 'Grey']);
const isOldColor = color => OLD_COLORS.has(color);
exports.isOldColor = isOldColor;
//# sourceMappingURL=isOldColor.js.map